import React, { useState } from "react";
import TabPanel from "../../../components/TabPanel";

// material ui
import Typography from "@material-ui/core/Typography";
// import useStyles from "./styles";
import useStyles from "./style";
// import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import RedeemIcon from "@material-ui/icons/Redeem";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { date } from "../../../utils/dateTime";
import { green, yellow } from "@material-ui/core/colors";
import ScrollContainer from "react-indiana-drag-scroll";
import { Skeleton } from "@material-ui/lab";

export default function RiwayatReward({ value, loading, penukaran }) {
  const classes = useStyles();
  // console.log(penukaran);
  const [dialogProduk, setDialogProduk] = useState(false);
  const [drawerProduk, setDrawerProduk] = useState({
    open: false,
    data: {},
  });
  function ProdukDialog() {
    const [statusReward, setStatusReward] = React.useState("pending");

    const filterHistory = penukaran
      ?.filter((a) => a.status === statusReward)
      ?.sort(
        (a, b) => b?.created_at?.toMillis?.() - a?.created_at?.toMillis?.()
      );
    return (
      <Dialog
        open={dialogProduk}
        onClose={() => {
          setDialogProduk(false);
        }}
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
    >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={() => {
                setDialogProduk(false);
              }}
              style={{ marginRight: 15 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Riwayat Reward</Typography>
          </div>
        </DialogTitle>
        {/* <Header
          title="Riwayat Reward"
          type="with-title"
          onClick={() => {
            setDialogProduk(false);
          }}
        /> */}
        <DialogContent dividers style={{ background: "#efefef", padding: 10 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
              marginTop: 10,
            }}
          >
            <div>
              <Typography noWrap style={{ fontSize: 14 }}>
                Status :
              </Typography>
            </div>
            <ScrollContainer
              style={{
                display: "flex",
                overflowX: "auto",
                flexWrap: "nowrap",
                marginLeft: "10px",
              }}
            >
              {" "}
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  color={statusReward === "pending" ? "primary" : ""}
                  size="small"
                  onClick={() => {
                    setStatusReward("pending");
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 13 }}
                    variant="button"
                  >
                    Sedang Ditinjau
                  </Typography>
                </Button>
              </div>
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  color={statusReward === "approved" ? "primary" : ""}
                  size="small"
                  onClick={() => {
                    setStatusReward("approved");
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 13 }}
                    variant="button"
                  >
                    Telah Disetujui
                  </Typography>{" "}
                </Button>
              </div>
              <div style={{ marginRight: "10px" }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  color={statusReward === "rejected" ? "primary" : ""}
                  onClick={() => {
                    setStatusReward("rejected");
                  }}
                >
                  <Typography
                    noWrap
                    style={{ textTransform: "capitalize", fontSize: 13 }}
                    variant="button"
                  >
                    Ditolak
                  </Typography>
                </Button>
              </div>
            </ScrollContainer>
          </div>
          {filterHistory?.length !== 0 ? (
            <>
              {filterHistory?.map?.((item) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: "10px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                    onClick={() => {
                      setDrawerProduk({
                        open: true,
                        data: item,
                      });
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "90%",
                      }}
                    >
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                          // borderRadius: 50,
                        }}
                        src={
                          item?.product_reward?.variantIdSelected
                            ?.thumbnail?.[0]
                        }
                        alt="logo"
                      />
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              // noWrap={true}
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.product_reward?.nama}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 14 }}>
                            {item?.status === "approved" &&
                            item.bukti_pengiriman
                              ? "Reward telah dikirim"
                              : item?.status === "approved"
                              ? "Reward sedang diproses"
                              : item?.status === "pending"
                              ? "Reward sedang ditinjau"
                              : "Reward ditolak"}
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "darkgray" }}
                          >
                            click untuk melihat detail
                          </Typography>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 14 }}>
                            {item?.updated_at
                              ? date(item?.updated_at?.toDate?.())
                              : date(item?.created_at?.toDate?.())}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        // marginRight: "1,5%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          // marginLeft: "1.5%",
                          marginRight: "5%",
                        }}
                      >
                        <RedeemIcon
                          color={
                            item?.status === "rejected"
                              ? "error"
                              : item?.status === "pending"
                              ? "primary"
                              : ""
                          }
                          style={
                            item?.status === "approved" && item.bukti_pengiriman
                              ? {
                                  color: green[500],
                                }
                              : item?.status === "approved"
                              ? {
                                  color: yellow[700],
                                }
                              : {}
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100px",
                borderRadius: 8,
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "gainsboro",
              }}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  // marginTop: "2.5%",
                  fontWeight: "bold",
                }}
              >
                Tidak Ada Data
              </Typography>
            </div>
          )}
        </DialogContent>
      </Dialog>
    );
  }

  function DrawerDetail() {
    return (
      <Drawer
        anchor="bottom"
        open={drawerProduk?.open}
        onClose={() => {
          setDrawerProduk({
            open: false,
            data: {},
          });
        }}
        classes={{
          paper: classes.root2,
          root: classes.root2,
        }}
      >
        <div style={{ margin: "25px" }}>
          <Typography
            style={{
              display: "flex",
              marginTop: "15px",
              fontSize: 17.5,
              marginBottom: "10px",
              fontWeight: "bold",
            }}
          >
            Detail Penukaran Reward
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                // marginLeft: "1.5%",
                width: "70%",
              }}
            >
              <Typography
                // align="center"
                style={{
                  display: "flex",
                  fontSize: 17,
                }}
              >
                Status :
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "30%",
                // marginRight: "1,5%",
                justifyContent: "flex-end",
              }}
            >
              <div>
                <Typography
                  // align="center"
                  color="primary"
                  style={{
                    display: "flex",
                    fontSize: 17,
                  }}
                >
                  {drawerProduk?.data?.status}
                </Typography>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: "15px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                // marginLeft: "1.5%",
                width: "70%",
              }}
            >
              <Typography
                // align="center"
                style={{
                  display: "flex",
                  fontSize: 17,
                }}
              >
                Harga point :
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "30%",
                // marginRight: "1,5%",
                justifyContent: "flex-end",
              }}
            >
              <div>
                <Typography
                  // align="center"
                  style={{
                    display: "flex",
                    fontSize: 17,
                  }}
                >
                  {
                    drawerProduk?.data?.product_reward?.variantIdSelected
                      ?.harga_poin
                  }
                </Typography>
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              // marginLeft: 24,
              border: "1px solid ",
              // marginRight: 24,
              borderRadius: 4,
              padding: "12px",
            }}
          >
            <div>
              <Typography style={{ fontSize: 15 }}>Nama Produk</Typography>
            </div>
            <div style={{ display: "inline-grid" }}>
              <Typography style={{ fontSize: 13, color: "darkgray" }}>
                {drawerProduk?.data?.product_reward?.nama}
              </Typography>
            </div>
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: 15 }}>Catatan</Typography>
            </div>
            <div style={{ display: "inline-grid" }}>
              <Typography style={{ fontSize: 13, color: "darkgray" }}>
                {drawerProduk?.data?.catatan === "" ||
                !drawerProduk?.data?.catatan
                  ? "-"
                  : drawerProduk?.data?.catatan}
              </Typography>
            </div>
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: 15 }}>
                Alamat Pengiriman
              </Typography>
            </div>
            <div style={{ display: "inline-grid" }}>
              <Typography style={{ fontSize: 13, color: "darkgray" }}>
                {drawerProduk?.data?.alamat_pengiriman?.nama_penerima} (
                {drawerProduk?.data?.alamat_pengiriman?.no_telepon})
              </Typography>
              <Typography style={{ fontSize: 13, color: "darkgray" }}>
                {drawerProduk?.data?.alamat_pengiriman?.kelurahan?.name},{" "}
                {drawerProduk?.data?.alamat_pengiriman?.kecamatan?.name},{" "}
                {drawerProduk?.data?.alamat_pengiriman?.kota?.name},{" "}
                {drawerProduk?.data?.alamat_pengiriman?.provinsi?.name},{" "}
                {drawerProduk?.data?.alamat_pengiriman?.kelurahan?.postcode}
              </Typography>
            </div>
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: 15 }}>Resi Pengiriman</Typography>
            </div>
            <div style={{ display: "inline-grid" }}>
              <Typography style={{ fontSize: 13, color: "darkgray" }}>
                {drawerProduk?.data?.shipper_info
                  ? drawerProduk?.data?.shipper_info?.short_id
                  : drawerProduk?.data?.resi_pengiriman_reward === "" ||
                    !drawerProduk?.data?.resi_pengiriman_reward
                  ? "-"
                  : drawerProduk?.data?.resi_pengiriman_reward}
              </Typography>
            </div>
          </div>
          {drawerProduk?.data?.shipper_info?.label_url ||
          drawerProduk?.data?.bukti_pengiriman ? (
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                window.open(
                  drawerProduk?.data?.bukti_pengiriman
                    ? drawerProduk?.data?.bukti_pengiriman
                    : drawerProduk?.data?.shipper_info?.label_url
                );
              }}
            >
              Bukti Pengiriman
            </Button>
          ) : null}
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            size="small"
            style={{ marginTop: "10px" }}
            onClick={() => {
              setDrawerProduk({
                open: false,
                data: {},
              });
            }}
          >
            Tutup
          </Button>
        </div>

        {/* </div> */}
      </Drawer>
    );
  }

  return (
    <TabPanel value={value} className={classes.panel} index="reward">
      {penukaran?.length !== 0 && !loading ? (
        <div style={{  marginLeft: -10, marginRight: -10, marginTop: -10  }}>
          {penukaran
            ?.sort(
              (a, b) =>
                b?.created_at?.toMillis?.() - a?.created_at?.toMillis?.()
            )
            ?.map?.((item, index) => {
              if (index < 5) {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      borderRadius: 8,
                      marginBottom: "10px",
                      padding: "10px",
                      backgroundColor: "white",
                    }}
                    onClick={() => {
                      setDrawerProduk({
                        open: true,
                        data: item,
                      });
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "1.5%",
                        width: "90%",
                      }}
                    >
                      <img
                        style={{
                          width: 75,
                          height: 75,
                          marginRight: "10px",
                          // borderRadius: 50,
                        }}
                        src={
                          item?.product_reward?.variantIdSelected
                            ?.thumbnail?.[0]
                        }
                        alt="logo"
                      />
                      <div style={{ marginLeft: "1.5%" }}>
                        <div style={{ display: "flex" }}>
                          <div style={{ display: "inline-grid" }}>
                            <Typography
                              // noWrap={true}
                              style={{
                                fontSize: 15,
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.product_reward?.nama}
                            </Typography>
                          </div>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 14 }}>
                            {item?.status === "approved" &&
                            item.bukti_pengiriman
                              ? "Reward telah dikirim"
                              : item?.status === "approved"
                              ? "Reward sedang diproses"
                              : item?.status === "pending"
                              ? "Reward sedang ditinjau"
                              : "Reward ditolak"}
                          </Typography>
                        </div>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap
                            style={{ fontSize: 13, color: "darkgray" }}
                          >
                            click untuk melihat detail
                          </Typography>
                        </div>
                        <div>
                          <Typography style={{ fontSize: 14 }}>
                            {item?.updated_at
                              ? date(item?.updated_at?.toDate?.())
                              : date(item?.created_at?.toDate?.())}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "10%",
                        // marginRight: "1,5%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div
                        style={{
                          // marginLeft: "1.5%",
                          marginRight: "5%",
                        }}
                      >
                        <RedeemIcon
                          color={
                            item?.status === "rejected"
                              ? "error"
                              : item?.status === "pending"
                              ? "primary"
                              : ""
                          }
                          style={
                            item?.status === "approved" && item.bukti_pengiriman
                              ? {
                                  color: green[500],
                                }
                              : item?.status === "approved"
                              ? {
                                  color: yellow[700],
                                }
                              : {}
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
              } else {
                return null;
              }
            })}
        </div>
      ) : (
        <>
          {loading ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "25px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    // marginLeft: "1.5%",
                    width: "60%",
                  }}
                >
                  {/* <Avatar className={classes.medium}> */}
                  <Skeleton
                    variant="rect"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "8px",
                    }}
                  />
                  {/* </Avatar> */}
                  <div style={{ marginLeft: "10px", width: "60%" }}>
                    <div style={{ width: "100%" }}>
                      <Skeleton variant="text" />
                    </div>
                    <div style={{ width: "80%", marginTop: "5px" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "40%",
                    // marginRight: "1,5%",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      width: "100px",
                      // , marginRight: "5%"
                    }}
                  >
                    <Skeleton variant="text" />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                // justifyContent: "space-between",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100px",
                borderRadius: 8,
                marginBottom: "20px",
                padding: "10px",
                backgroundColor: "gainsboro",
              }}
            >
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                  alignItems: "center",
                  fontSize: 14,
                  // marginTop: "2.5%",
                  fontWeight: "bold",
                }}
              >
                Tidak Ada Data
              </Typography>
            </div>
          )}
        </>
      )}
      {penukaran?.length < 5 ? null : (
        <Typography
          color="primary"
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            cursor:"pointer"
          }}
          onClick={() => {
            setDialogProduk(true);
          }}
        >
          Lihat Lainnya
        </Typography>
      )}
      <ProdukDialog />
      <DrawerDetail />
    </TabPanel>
  );
}
